"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var createNextID = function (options) {
    var _a = options || {}, _b = _a.prefix, prefix = _b === void 0 ? 'id' : _b, _c = _a.offset, offset = _c === void 0 ? 0 : _c;
    var id = offset;
    return function () { return prefix + "-" + id++; };
};
exports.default = createNextID;
//# sourceMappingURL=nextID.js.map